<script>
import Pagination from "@/components/Pagination";
import ErrorComponent from "@/components/ErrorComponent";
import Alert from "@/components/Alert";
import { constants } from "crypto";
import router from "../../router";
import EventBus from "@/eventBus";
import accessible from '@/mixins/accessible'

export default {
  name: "InventoryCount",
  components: {
    Pagination,
    ErrorComponent,
    Alert
  },
  data() {
    return {
      currentPage: 1,
      totalPage: 0,
      itemsPerPage: 10,
      list: [],
      storeList: [],
      currentSorting: "",
      filterObj: {
        store_id: "",
        inventory_count_status: "",
        sort_by: "",
        order_by: ""
      }
    };
  },

  mixins: [accessible],

  methods: {
    pageChange(page) {
      this.getList(page);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(1);
    },
    getList(page, sortBy, orderBy) {
      if (sortBy) {
        this.filterObj.sort_by = sortBy;
      }
      if (orderBy) {
        this.filterObj.order_by = orderBy;
      }
      this.list = [];
      this.currentPage = page;

      this.$api
        .getAPI({
          _action: "/inventory_count/list/" + this.itemsPerPage + "/" + page,
          _body: this.filterObj
        })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.list = res.list;
          }
          if (page == 1) {
            if (res.count != null && res.count > 0) {
              this.$refs.listPagination.setTotalCount(res.count);
            } else {
              this.$refs.listPagination.setTotalCount(0);
            }
          }

          if (!res.list || res.list.length <= 0) {
            this.$refs.errorComonent.setTitle(this.$lang.messages.no_inventory_count_found);
          } else if (this.$refs.errorComonent.isShowMessage()) {
            this.$refs.errorComonent.setTitle();
          }
        })
        .catch(e => {
          this.$refs.errorComonent.setTitle();
        });
    },
    getStoreList() {
      this.$api
        .getAPI({ _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.storeList = res.list;
          }
        })
        .catch(e => {});
    },

    retry() {
      this.getList(1);
    },

    view(id) {
      router.push("/view-inventory-count/" + id);
    },
    sorting(e, sortBy) {
      var orderBy = "ASC";
      var className = "sorting_asc";
      var classes = e.target.className;
      if (classes.includes("sorting_asc")) {
        className = "sorting_desc";
      }

      $(".sorting_asc").removeClass("sorting_asc");
      $(".sorting_desc").removeClass("sorting_desc");

      if (className == "sorting_asc") {
        $(e.target)
          .addClass("sorting_asc")
          .removeClass("sorting_desc");
        orderBy = "ASC";
      } else if (className == "sorting_desc") {
        $(e.target)
          .addClass("sorting_desc")
          .removeClass("sorting_asc");
        orderBy = "DESC";
      }
      this.getList(1, sortBy, orderBy);
    }
  },
  mounted() {
    this.getStoreList();
    this.getList(1);

    // get current user profile
    EventBus.$on("GET_ME_SUCCESS", payload => {
      this.currentUser = payload
    });
  }
};
</script>
<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3 text-md-right text-center">
              <div
                class="text-right custom-select-dd d-inline-block mr-lg-3 mr-md-1 mr-md-1 mr-2 mb-3 mb-lg-0 w-xs-100"
                style="width: 160px;">
                <select
                  class="form-control"
                  v-model="filterObj.inventory_count_status"
                  @change="getList(1)">
                  <option value>{{$lang.messages.status}}</option>
                  <option value="PENDING">{{$lang.messages.pending}}</option>
                  <option value="In_PROGRESS">{{$lang.messages.in_progress}}</option>
                  <option value="COMPLETE">{{$lang.messages.completed}}</option>
                </select>
              </div>

              <div
                class="text-right custom-select-dd d-inline-block mr-lg-3 mr-md-1 mb-3 mb-lg-0 w-xs-100"
                style="width: 160px;">
                <select
                  v-model="filterObj.store_id"
                  name="source_store_id"
                  class="form-control"
                  @change="getList(1)">
                  <option value>{{$lang.messages.store}}</option>
                  <option v-for="obj in storeList" :key="obj.id" :value="obj.id">{{obj.name}}</option>
                </select>
              </div>
              <button
                @click="checkPendingAccountStatus($event, 'add-inventory-count')"
                class="btn btn-primary px-4">+ {{$lang.messages.add_inventory_count}}</button>
            </div>

            <div class="card rounded-5">
              <div class="card-body table-responsive">
                <table class="table table-striped table-style-1">
                  <thead>
                    <tr>
                      <th scope="col">Sr.no</th>
                      <th scope="col">{{$lang.messages.inventory_count}} #</th>
                      <th scope="col">{{$lang.messages.date_created}}</th>
                      <th scope="col">{{$lang.messages.date_completed}}</th>
                      <th scope="col">{{$lang.messages.store}}</th>
                      <th scope="col">{{$lang.messages.status}}</th>
                      <th scope="col" width="40%">{{$lang.messages.notes}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      class="clickable-row"
                      v-for="(obj,i) in list"
                      :key="obj.id"
                      @click="view(obj.id)"
                    >
                      <td>{{(currentPage -1) * itemsPerPage + i +1}}</td>
                      <td>{{obj.ic_number}}</td>
                      <td>{{obj.created_at | moment("DD MMM YYYY") }}</td>
                      <td v-if="obj.date_completed">{{obj.date_completed | moment("DD MMM YYYY") }}</td>
                      <td v-else>-</td>
                      <td>{{obj.store_name}}</td>
                      <td>
                        <span
                          class="text-success"
                          v-if="obj.inventory_count_status == 'COMPLETED'"
                        >{{$lang.messages.completed}}</span>
                        <span
                          class="text-warning"
                          v-else-if="obj.inventory_count_status == 'In_PROGRESS'"
                        >{{$lang.messages.in_progress}}</span>
                        <span
                          class="text-danger"
                          v-else-if="obj.inventory_count_status == 'PENDING'"
                        >{{$lang.messages.pending}}</span>
                      </td>
                      <td>{{obj.note}}</td>
                    </tr>
                  </tbody>
                </table>
                <ErrorComponent @retry="retry()" ref="errorComonent" />
              </div>
            </div>

            <div class="page-bottom-pagination text-right">
              <Pagination
                @page-change="pageChange"
                @items-per-page-change="itemsPerPageChange()"
                ref="listPagination"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
